/**
 * A screen's primary action, drawn in the shell topbar where the frames put
 * it. The topbar's action slot is hidden below `lg`, and the mobile topbar
 * carries no actions, so below `lg` the same action renders in the page.
 */

import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

const SLOT = 'topbar-actions';

/** Mounted in the topbar's action area; `contents` lets the portalled
 *  action sit in the topbar's own flex row. */
export function TopbarActionsSlot(): ReactNode {
  return <div data-slot={SLOT} className="contents" />;
}

export function TopbarActions(props: { children: ReactNode }): ReactNode {
  const [slot, setSlot] = useState<Element | null>(null);
  useEffect(() => {
    setSlot(document.querySelector(`[data-slot="${SLOT}"]`));
  }, []);
  if (slot === null) return <div className="flex justify-end">{props.children}</div>;
  return (
    <>
      {createPortal(props.children, slot)}
      <div className="flex justify-end lg:hidden">{props.children}</div>
    </>
  );
}
